import { Controller } from "@hotwired/stimulus"

// Clears a form once Turbo has finished submitting it, so the next entry starts
// from an empty box.
export default class extends Controller {
    reset(event) {
        if (event.detail?.success === false) return

        this.element.reset()
        this.element.querySelector("input[type=text]")?.focus()
    }
}
